import {Directive, ElementRef, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {animate, AnimationBuilder, AnimationPlayer, style} from '@angular/animations';

@Directive({
  selector: '[appPageAnimation]',
})
export class PageAnimationDirective implements OnInit, OnDestroy {
  // Todo: finir et utiliser ce composant pour les transitions de pages
  private factory;
  private player: AnimationPlayer;

  constructor(
    private builder: AnimationBuilder,
    private el: ElementRef,
    private templateRef: TemplateRef<any>,
    private containerRef: ViewContainerRef,
  ) {}

  ngOnInit() {
    this.factory = this.builder.build(this.show());
    this.player = this.factory.create(this.el.nativeElement);
    this.player.play();
  }

  ngOnDestroy() {
    this.player.destroy();
    this.factory = this.builder.build(this.hide());
    this.player = this.factory.create(this.el.nativeElement);
    this.player.play();
  }

  private hide() {
    return [
      style({
        transform: 'translateX(0)',
      }),
      animate(
        '1s cubic-bezier(.16,.78,.26,.99)',
        style({
          transform: 'translateX(100%)',
        }),
      ),
    ];
  }

  private show() {
    return [
      style({
        transform: 'translateX(100%)',
        position: 'fixed',
      }),
      animate(
        '1s cubic-bezier(.16,.78,.26,.99)',
        style({
          transform: 'translateX(0)',
        }),
      ),
    ];
  }
}
